import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { ExitApi, NotificationInfo } from 'src/app/core/api.gen';
import { environment } from 'src/environments/environment';
import { Logger } from '../../utils/Logger';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  huburl: string;
  constructor(private exitApi: ExitApi) {
    this.huburl = environment.apiBaseUrl + '/notify';
  }

  public data: number;
  private hubConnection: signalR.HubConnection;
  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()      
      .withUrl(this.huburl)
      //.configureLogging(signalR.LogLevel.Debug)
      .build();

    this.hubConnection
      .serverTimeoutInMilliseconds = 120000;

    this.hubConnection
      .start()
      .then(() => Logger.log("Connection started"))
      .catch(err => Logger.error('Error while starting - ' + err));
  }

  public employeeDataListener = (method: string, usrid: number, type: string) => {
    this.hubConnection.on(method, (data) => {
      this.exitApi.getNotificationCount(usrid, type).subscribe(resp => {
        this.data = resp;
      });
    });
  }

}
